import secureLocalStorage from 'react-secure-storage';
import {
    FETCH_START,
    FETCH_END,
    CHANGE_MANAGEMENT_LIST_DATA_SUCCESS,
    CHANGE_MANAGEMENT_SINGLE_DATA_SUCCESS,
    CHANGE_MANAGEMENT_DROP_DATA_SUCCESS,
    CHANGE_MANAGEMENT_TABLE_DATA_SUCCESS,
    CHANGE_MANAGEMENT_COUNT_SUCCESS,
    CHANGE_MANAGEMENT_RECORD_SUCCESS,
    CHANGE_MANAGEMENT_RECORD_CLEAR
} from './ActionTypes';
import axios from '../../../../axios.conf';
import { toast as globalToast } from '../../../../components/ToastManager';
import { history } from '../../../../components/Helpers';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';
export const fetchStart = () => {
    return {
        type: FETCH_START,
    };
};

export const fetchEnd = () => {
    return {
        type: FETCH_END,
    };
};
export const fetchChangeManagementList = (pagination, limit) => {
    return (dispatch) => {
        dispatch(fetchStart());
        fetchChangeManagementListAPI(pagination, limit).then((response) => {
            dispatch(fetchEnd());
            dispatch(fetchChangeManagementListSuccess(response.data.response));
        });
    };
};

const fetchChangeManagementListAPI = (pagination, limit) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    result = axios.get('change-management',
        // + pagination + '&limit=' + limit
        {
            headers: headers,
        },
    );
    return result;
};

export const fetchChangeManagementListSuccess = (data) => {
    return {
        type: CHANGE_MANAGEMENT_LIST_DATA_SUCCESS,
        data,
    };
};
// Delete Change Management Internal Data
export const deleteChangeManagementInternalData = (id, pageID, systemName) => {
    return (dispatch) => {
        deleteChangeManagementInternalDataApi(id, pageID)
            .then(async (response) => {
                const logNumber = response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                } else {
                    const deletedCount = response.data.response?.number_of_records_deleted ?? 0;
                    globalToast.showSuccess(`Number of records deleted: ${deletedCount}`);
                }
                setTimeout(() => {
                    // Same record, so the refetch needs the same source system.
                    dispatch(handleChangeManagement(null, pageID, 'get', systemName));
                }, 500);
            })
            .catch(async (error) => {
                const logNumber = error?.response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                }
            });
    };
};

const deleteChangeManagementInternalDataApi = (id) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    result = axios.delete('change-management?dataID=' + id, {
        headers: headers,
    });
    return result;
};
export const handleChangeManagement = (data, editId, type, systemName) => {
    return (dispatch) => {
        dispatch(fetchStart());
        handleChangeManagementAPI(data, editId, type, systemName)
            .then(async (response) => {
                dispatch(fetchEnd());
                if (type === 'get' || type === 'create' || type === 'updated') {
                    dispatch(getChangeManagementSingleDataSuccess(response.data.response));
                    // Same contract as the other calls below: when the backend returns a
                    // log_number the messages live in the execution log, so the popup
                    // renders them instead of a plain toast.
                    const logNumber = response?.data?.log_number;
                    if (logNumber) {
                        await handleExecutionLog(dispatch, logNumber);
                    }
                }
                else if (type === 'blob_download') {
                    const logNumber = response?.data?.log_number;
                    if (logNumber) {
                        await handleExecutionLog(dispatch, logNumber);
                    }
                    // dispatch(fetchChangeManagementList(1, 0));
                    // dispatch(getCountChangeMgmt());
                }
                else if (type === 'release') {
                    const logNumber = response?.data?.log_number;
                    if (logNumber) {
                        await handleExecutionLog(dispatch, logNumber);
                    }
                    dispatch(fetchChangeManagementList(1, 0));
                    dispatch(getCountChangeMgmt());
                }
                else if (type == 'local_download') {
                    // 👇 Handle file download
                    if (response?.data) {
                        globalToast.showInfo("Downloading data...");
                        // Get filename from headers
                        let filename = `release_data_${new Date().toISOString().split("T")[0]}.json`; // fallback
                        const contentType = response.headers["content-type"];
                        if (contentType && contentType.includes("filename=")) {
                            const match = contentType.match(/filename=([^;]+)/);
                            if (match && match[1]) {
                                filename = match[1].trim().replace(/['"]/g, ""); // remove quotes if any
                            }
                        }
                        // Create blob and trigger download
                        const blob = new Blob([response.data], { type: "application/json" });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", filename);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    dispatch(fetchChangeManagementList(1, 0));
                    dispatch(getCountChangeMgmt());
                }
                else {
                    const logNumber = response?.data?.log_number;
                    if (logNumber) {
                        await handleExecutionLog(dispatch, logNumber);
                    } else {
                        globalToast.showSuccess(response?.data?.message);
                    }
                    // history.push('/change-management')
                    dispatch(fetchChangeManagementList(1, 0));
                    dispatch(getCountChangeMgmt());
                }
            })
            .catch(async (error) => {
                dispatch(fetchEnd());
                // Failures carry their details in the execution log too — same as the
                // upload flow below; the generic axios interceptor toast covers the rest.
                const logNumber = error?.response?.data?.log_number;
                if (logNumber) {
                    await handleExecutionLog(dispatch, logNumber);
                }
            });
    };
};

const handleChangeManagementAPI = (data, editId, type, systemName) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    // The record is scoped by the source system it came from, so the reads and the
    // release carry it as a query param. Omitted when the caller has no system name
    // rather than sent empty, so the request stays as it was before.
    const systemParams = systemName ? { system_name: systemName } : {};
    var result;
    if (type == 'get') {
        result = axios.get('change-management/' + editId, { headers: headers, params: systemParams });
    } else if (editId) {
        if (type == 'delete') {
            result = axios.delete('change-management/' + editId, { headers: headers });
        } else if (type == 'blob_download') {
            result = axios.get('change-management/' + editId + '/exportfile', {
                headers: headers,
                params: { ...systemParams, location: 'blob' },
            });
        } else if (type === 'release') {
            result = axios.post('change-management/' + editId + '/release', data, {
                headers: headers,
                params: systemParams,
            });
        }
        else if (type == 'local_download')
            result = axios.get('change-management/' + editId + '/exportfile', {
                headers: headers,
                params: { ...systemParams, location: 'local' },
                responseType: 'blob',
            });
        else
            result = axios.put('change-management/' + editId, data, {
                headers: headers,
            });
    } else {
        result = axios.post('change-management', data, { headers: headers });
    }
    return result;
};
export const getChangeManagementSingleDataSuccess = (data) => {
    return {
        type: CHANGE_MANAGEMENT_SINGLE_DATA_SUCCESS,
        data,
    };
};
export const fetchChangeManagementDropdownList = () => {
    return (dispatch) => {
        dispatch(fetchStart());
        fetchChangeManagementDropdownListAPI().then((response) => {
            dispatch(fetchEnd());
            dispatch(fetchChangeManagementDropdownListSuccess(response.data.response));
        });
    };
};

const fetchChangeManagementDropdownListAPI = () => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    let result;
    result = axios.get('get-table-names?isChangeManagement=true', { headers: headers, });
    return result;
};

export const fetchChangeManagementDropdownListSuccess = (data) => {
    return {
        type: CHANGE_MANAGEMENT_DROP_DATA_SUCCESS,
        data,
    };
};
export const fetchChangeManagementTableData = (tablename) => {
    return (dispatch) => {
        dispatch(fetchStart());
        fetchChangeManagementTableDataAPI(tablename).then((response) => {
            dispatch(fetchEnd());
            dispatch(fetchChangeManagementTableDataSuccess(response.data.response));
        });
    };
};

const fetchChangeManagementTableDataAPI = (tablename) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    let result;
    result = axios.post(`search/generic/${tablename}`, {}, { headers: headers, });
    return result;
};

export const fetchChangeManagementTableDataSuccess = (data) => {
    return {
        type: CHANGE_MANAGEMENT_TABLE_DATA_SUCCESS,
        data,
    };
};
export const getCountChangeMgmt = () => {
    return (dispatch) => {
        dispatch(fetchStart());
        getCountChangeMgmtAPI().then((response) => {
            dispatch(fetchEnd());
            dispatch(getCountChangeMgmtSuccess(response.data.response));
        });
    };
};

const getCountChangeMgmtAPI = () => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    let result;
    result = axios.get('change-management-count', { headers: headers, });
    return result;
};

export const getCountChangeMgmtSuccess = (data) => {
    return {
        type: CHANGE_MANAGEMENT_COUNT_SUCCESS,
        data,
    };
};
export const uploadChangeManagementFile = (data) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await uploadChangeManagementFileAPI(data);
            dispatch(fetchEnd());
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showSuccess(response?.data?.message);
            }
            dispatch(fetchChangeManagementList(1, 0));
            dispatch(getCountChangeMgmt());
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            const logNumber = error?.response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
        }
    };
};

// Imports a file already in blob storage, identified by name, instead of an
// uploaded one.
export const importChangeManagementBlobFile = (fileName) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await importChangeManagementBlobFileAPI(fileName);
            dispatch(fetchEnd());
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            } else {
                globalToast.showSuccess(response?.data?.message);
            }
            dispatch(fetchChangeManagementList(1, 0));
            dispatch(getCountChangeMgmt());
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            const logNumber = error?.response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
        }
    };
};

// Reads an assigned entry's row as it stands in its own table right now, rather
// than the snapshot the change-management record stored when the entry was added.
export const fetchChangeManagementRecord = (data) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await fetchChangeManagementRecordAPI(data);
            dispatch(fetchEnd());
            const logNumber = response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
            dispatch(fetchChangeManagementRecordSuccess(response?.data?.response));
            return response;
        } catch (error) {
            dispatch(fetchEnd());
            const logNumber = error?.response?.data?.log_number;
            if (logNumber) {
                await handleExecutionLog(dispatch, logNumber);
            }
        }
    };
};

const fetchChangeManagementRecordAPI = (data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    result = axios.post('change-management/record', data, {
        headers: headers,
    });
    return result;
};

export const fetchChangeManagementRecordSuccess = (data) => {
    return {
        type: CHANGE_MANAGEMENT_RECORD_SUCCESS,
        data,
    };
};

// Dropped when the details dialog closes, so the next row never opens on the
// record fetched for the previous one.
export const clearChangeManagementRecord = () => {
    return {
        type: CHANGE_MANAGEMENT_RECORD_CLEAR,
    };
};

const uploadChangeManagementFileAPI = (data) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
        'Content-Type': 'multipart/form-data;',
    };
    var result;
    result = axios.post('change-management/import', data, {
        headers: headers,
    });
    return result;
};

const importChangeManagementBlobFileAPI = (fileName) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    result = axios.post('change-management/import', null, {
        headers: headers,
        params: { filename: fileName },
    });
    return result;
};